import { createSlice } from '@reduxjs/toolkit';
import { DataRoomState } from './data-room.state';
import { FetchDataRoom } from './thunks/fetch-data-room.thunk';
import { UpdateVDRPermissions } from './thunks/update-vdr-permissions.thunk';

const initialState: DataRoomState = {
    rootFolder: undefined,
    isLoading: false,
    status: 'idle',
    error: '',
};

const dataRoomSlice = createSlice({
    name: 'dataRoom',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(FetchDataRoom.pending, (state) => {
                setPendingState(state);
            })
            .addCase(FetchDataRoom.rejected, (state, action) => {
                setRejectedState(state, action.error.message || 'Failed to fetch data room');
            })
            .addCase(FetchDataRoom.fulfilled, (state, action) => {
                state.rootFolder = action.payload;
                setSucceededState(state);
            })
            .addCase(UpdateVDRPermissions.pending, (state) => {
                setPendingState(state);
            })
            .addCase(UpdateVDRPermissions.rejected, (state, action) => {
                setRejectedState(state, action.error.message || 'Failed to update permissions');
            })
            .addCase(UpdateVDRPermissions.fulfilled, (state) => {
                setSucceededState(state);
            });
    },
});

const setRejectedState = (state: DataRoomState, errorMessage: string) => {
    state.isLoading = false;
    state.status = 'failed';
    state.error = errorMessage;
};

const setPendingState = (state: DataRoomState) => {
    state.isLoading = true;
    state.status = 'loading';
    state.error = '';
};

const setSucceededState = (state: DataRoomState) => {
    state.isLoading = false;
    state.status = 'succeeded';
    state.error = '';
};

export const {} = dataRoomSlice.actions;
export default dataRoomSlice.reducer;

